export const endpoints = {
  templates: "/templates",
  tenantConfig: "/tenantConfig",
  resumeStore: "/resume",
  generateTex: "/generateFormat"
}
